<template>
  <v-card class="rounded-lg pa-4">
    <v-card-title class="d-flex align-center mb-2" style="color: #444; font-size: 1.1rem;">
      <v-icon left color="#db4d4f" size="28">mdi-clock-outline</v-icon>
      {{ $t('titles.starting_pme') }}
    </v-card-title>
    <v-card-subtitle class="pb-0 mb-5" style="color: #666">
      {{ $t('titles.date_hour_pme') }}
    </v-card-subtitle>
    <v-card-text>
      <v-form @submit.prevent="handleSubmit" ref="form">
        <v-row dense>
          <v-col cols="12">
            <v-text-field
             data-cy="input-pme-start-datetime"
              class="rounded-lg"
              color="#256936"
              :rules="formRules"
              outlined
              type="datetime-local"
              v-model="form.pme_start_datetime"
              dense
            >
              <template v-slot:label>
                {{ $t('inputs.starting_pme.pme_start_datetime') }}<span style="color: red">*</span>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row dense class="justify-end mt-2">
          <v-btn class="rounded-lg mr-2" color="#e74c3c" small text elevation="0" @click="$emit('cancel')">
            <span>{{$t('buttons.cancel')}}</span>
          </v-btn>
          <v-btn 
            data-cy="btn-save-pme"
          class="rounded-lg" small elevation="0" :loading="loading" color="#41916b" type="submit">
            <span class="textBtn" style="color: white">{{$t('buttons.save')}}</span>
          </v-btn>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "StartingPME",

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: { pme_start_datetime: null },
      formRules: [(v) => !!v || "Campo obrigatório."],
    };
  },

  methods: {
    handleSubmit() {
      if (this.$refs.form.validate()) {
        this.$emit("submit", this.form.pme_start_datetime);
      }
    },
  },
};
</script>
